import React from "react";

// Four café facts occupy the reference nutrition strip's positions.
// No nutrition or dietary claims are made.
export default function Facts({ dish }) {
  return (
    <dl className="ro-facts">
      <div>
        <dt>Price</dt>
        <dd>{dish.price}</dd>
      </div>
      <div>
        <dt>Serving</dt>
        <dd>{dish.portion}</dd>
      </div>
      <div>
        <dt>Category</dt>
        <dd>{dish.category}</dd>
      </div>
      <div>
        <dt>Occasion</dt>
        <dd>{dish.occasion}</dd>
      </div>
    </dl>
  );
}
